module.exports = __webpack_public_path__ + "img/app_logo.2c8d9f62.jpeg";